import {post} from './RequestUtil'

export const UserRequestUtil = {
  queryUserList (params, callback) {
    post('/user/list', params).then((response) => {
      callback && callback(response)
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/UserRequestUtil.js